import { FC } from "react";

interface Props {
  selecteditem: number;
}

export const AutoSlider: FC<Props> = ({ selecteditem }) => {
  const arrayPartners = [1, 2, 6, 4, 7, 3, 1, 2, 6, 7, 4, 3, 1, 2, 6, 4, 7, 3];

  return (
    <div className="slider">
      <div className="slide-track">
        {arrayPartners.map((partner, index) => (
          <div className="slide" key={index}>
            <img
              className="slideImg"
              style={{
                filter: selecteditem === 6 ? "invert(1)" : "invert(1)",
                transition: "all 0.5s ease-in-out",
              }}
              src={`./assets/functioning/partners/partner${partner}.svg`}
              alt="partners"
            />
          </div>
        ))}
      </div>
    </div>
  );
};
